<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>QR Obras</h2>
    <h3>Admin - Status</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-project">
      <a class="btn btn-primary" [routerLink]="['/qrobras/status/adicionar']">Novo</a>
    </div>
  </div>
</div>

<div class="system-table p-h-lg">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="title-width title-status-id">Id</th>
          <th class="title-status-nome">Nome</th>
          <th class="text-center width5">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let status of statusList">
          <tr>
            <td class="title">{{ status?.id }}</td>
            <td><span class="title-span">{{status?.name}}</span></td>
            <td class="text-center">
              <div class="btn-icon btn-icon-auto">
                <!--[routerLink]="obra.id"-->
                <a class="icon-table" [routerLink]="status?.id">
                  <img src="assets/images/svgs/editar1.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!statusList?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Status Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>